import { FormControl, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef, useMemo } from "react";
import { Controller, UseFormReturn } from "react-hook-form";
import { IMaskInput } from "react-imask";

import dayjs from "dayjs";
import { fieldValueToString } from "../../../../../../common/utils/react_hook_form_input_utils";

/**
 * FormProrrogarEmInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const FormProrrogarEmInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any) => onChange({ target: { name: props.name, value } })}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * FormProrrogarEmInput
 */

type Props = {
  name: string,
  label: string,
  reactHookForm: UseFormReturn<any>,
};

export const FormProrrogarEmInput = ({
  name,
  label,
  reactHookForm,
}: Props) => {
  const watchs = reactHookForm.watch(['dataAdmissao', 'prorrogarEm', 'experiencia']);

  const dataAdmissao = watchs[0] as Date;
  const prorrogarEm = watchs[1] as string;
  const experiencia = watchs[2] as string;

  const computedDate = useMemo(() => {
    if (!dataAdmissao) return null;
    if (!prorrogarEm || prorrogarEm.length <= 0) return null;
    if (!experiencia || experiencia.length <= 0) return null;
    return prorrogarEm.length > 0 && dayjs(dataAdmissao).add(parseInt(experiencia) - 1, 'day').add(parseInt(prorrogarEm), 'day').format('DD/MM/YYYY');
  }, [dataAdmissao, prorrogarEm, experiencia]);

  return (
    <Controller
      name={name}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        return (
          <FormControl variant="outlined" size="small">
            <InputLabel htmlFor={`input-${name}`} shrink={true} size="small">{label}</InputLabel>
            <OutlinedInput
              size="small"
              id={`input-${name}`}
              name={name}
              value={fieldValueToString(field.value)}
              label={label}
              notched={true}
              onChange={field.onChange}
              disabled={formState.disabled}
              inputComponent={FormProrrogarEmInputBase as any}
              inputProps={{
                mask: '000',
                placeholder: '___',
              }} />
            <p className="text-red-600 ms-2 mt-1">{computedDate}</p>
          </FormControl>
        );
      }} />
  );
}